import { render, staticRenderFns } from "./AccordionFilter.vue?vue&type=template&id=218dcd82&scoped=true"
import script from "./AccordionFilter.vue?vue&type=script&lang=js"
export * from "./AccordionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218dcd82",
  null
  
)

export default component.exports